import React, { useEffect, useState } from "react";
import EmployeeProfileCard from "./components/EmployeeProfileCard";
import AttendanceList from "./components/AttendanceList";
import LeaveList from "./components/LeaveList";
import LeaveBalanceList from "./components/LeaveBalanceList";
import BalanceList from "./components/BalanceList";
import SGPIList from "./components/SGPIList";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/Dropdown";
import { Btn } from "../../AbstractElements";
import { useChangePassword, usePasswordReset } from "../Authentication/useAuth";
import { Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useCanLoginApp,
  useChangeEmployeeStatus,
  useEmployeeDetailsById,
  useUpdateHrUserDates,
} from "./hooks/useEmployee";
import EditProfileModal from "./components/EditProfileModal";
import UserProfileModal from "./components/UserProfileModal";
import AccountInformation from "./components/AccountInformation";
import { FaLock } from "react-icons/fa";
import AccountLockedModal from "./components/AccountLockedModal";
import { showToast } from "../../utils/toastUtils";

const EmployeeDetails = () => {
  const location = useLocation();
  const [isEditProfile, setIsEditProfile] = useState(false);
  const [isResetPassModalOpen, setIsResetPassModalOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isAccountLocked, setIsAccountLocked] = useState(false);

  const [employeeData, setEmployeeData] = useState(
    location?.state?.employeeData
  );
  const navigate = useNavigate();

  // const employeeData = location?.state?.employeeData;

  console.log("employeeData====User Mangement", employeeData);
  const toggle = () => {
    setIsAccountLocked(!isAccountLocked);
  };

  const { data: EmployeeProfile, isLoading  } = useEmployeeDetailsById(
    {
      enable: !!employeeData?.EmployeeId,
      params: {
        employeeId: employeeData?.EmployeeId,
      },
    }
    // Ensure EmployeeId is present before making the request
  );

  const [profileData, setProfileData] = useState<any>(EmployeeProfile?.data || {});
  useEffect(() => {
  if (EmployeeProfile?.data) {
    setProfileData(EmployeeProfile.data);
  }
}, [EmployeeProfile]);


  const employeeProfileData = EmployeeProfile?.data || {};

  // Define required fields dynamically
  const requiredFields = {
    Name: "Name",
    Email: "Email",
    EmployeeCode: "EmployeeCode",
    Username: "Username",
    Role: "RoleName",
    Position: "PositionName",
    ReportTo: "ReportingToPositionName",
    LastLogin: "LastLogin",
    JoiningDate: "JoinDate",
    DateOfBirth: "BirthDate",
    Contact: "Phone",
    Remark: "Remark",
    ResignDate: "ResignDate",
    CanLogin: "CanLoginIntoApp",
    Status: "Status",
  };

  const toggleModal = () => {
    setIsEditProfile(!isEditProfile);
  };

  useEffect(() => {
    if (refresh) {
      window.location.reload();
    }
  }, [refresh]);
  const resetPasswordToggleModal = () => {
    setIsResetPassModalOpen(!isResetPassModalOpen);
    // Reset selected brand
  };

  const { mutate: updateStatus } = useChangeEmployeeStatus();
  const { mutate: updateCanLogin } = useCanLoginApp();
  const { mutate: updateHrUserDates } = useUpdateHrUserDates();

  const ResetPasswordModalContent = () => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [show, setShow] = useState(false);
    const changePasswordApi = useChangePassword();
    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      // console.log("Form Submitted:", {
      //   oldPassword,
      //   newPassword,
      //   confirmPassword,
      // });

      if (newPassword !== confirmPassword) {
        toast.error("Password and Confirm Password do not match");
        return;
      } else {
        changePasswordApi.mutate(
          {
            old_password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
          }, // Pass credentials
          {
            onSuccess: (data) => {
              handleClose();
            },
            onError: (error) => {
              console.error("Password change failed:", error);
            },
          }
        );
      }
    };
    const handleClose = () => {
      setIsResetPassModalOpen(false);
      setNewPassword("");
      setOldPassword("");
      setConfirmPassword("");
    };

    return (
      <form onSubmit={handleSubmit}>
        {/* Second Line */}
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div>
            <Label className="col-form-label">Old Password</Label>
            <div className="form-input position-relative">
              <Input
                type={show ? "text" : "password"}
                placeholder="Enter Old Password"
                onChange={(event) => setOldPassword(event.target.value)}
                value={oldPassword}
              />
              <div
                className="show-hide"
                style={{ position: "absolute", top: "22px", right: "20px" }}
                onClick={() => setShow(!show)}
              >
                <span className="show"> </span>
              </div>
            </div>
          </div>
          <div>
            <Label className="col-form-label">New Password</Label>
            <div className="form-input position-relative">
              <Input
                type={show ? "text" : "password"}
                placeholder="Enter New Password"
                onChange={(event) => setNewPassword(event.target.value)}
                value={newPassword}
              />
              <div
                className="show-hide"
                style={{ position: "absolute", top: "22px", right: "20px" }}
                onClick={() => setShow(!show)}
              >
                <span className="show"> </span>
              </div>
            </div>
          </div>
          <div>
            <Label className="col-form-label">Confirm Password</Label>
            <div className="form-input position-relative">
              <Input
                type={show ? "text" : "password"}
                placeholder="Enter Confirm Password"
                onChange={(event) => setConfirmPassword(event.target.value)}
                value={confirmPassword}
              />
              <div
                className="show-hide"
                style={{ position: "absolute", top: "22px", right: "20px" }}
                onClick={() => setShow(!show)}
              >
                <span className="show"> </span>
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start mt-3 gap-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            {"Submit"}
          </Btn>
          <Btn
            style={{
              backgroundColor: "#F9FAFC",
              color: "#000",
              border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={handleClose}
          >
            Cancel
          </Btn>
        </div>
      </form>
    );
  };

  const CustomStyle = {
    imageContainer: {
      width: "75%",
      height: "50%",
      // borderRadius: "50%",
      overflow: "hidden",
      marginBottom: "16px",
      // backgroundColor: "#fff",
      marginLeft: "16xp",
    },
    image: {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      ObjectFit: "cover",
    },
  };
  console.log('lockedddds',profileData)

  return (
    <div>
      <PageHeader
        title="Employee Profile"
        buttons={[
          {
            label: "Edit User",
            onClick: toggleModal,
            color: "#43B9B2",
          },
          // {
          //   label: "Reset Password",
          //   onClick: resetPasswordToggleModal,
          //   color: "#43B9B2",
          // },
          {
            label: "User Session",
            onClick: () =>
              navigate("/UserSession", {
                state: { UserId: employeeData?.UserId },
              }),
            color: "#43B9B2",
          },
        ]}
      />

      {/* Parent Container */}
      <div
        // className="container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px", // Spacing between the cards
          justifyContent: "space-between",
          padding: "0px 20px 0px 20px",
          width: "100%",
        }}
      >
        {profileData?.Islocked == true && (
          <div
            style={{
              flex: "1",
              background: "#E9CCCF",
              border: "1px solid red",
              color: "red",
              padding: "10px 15px",
              borderRadius: "2px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>
              {profileData?.LockedReason} : {profileData?.Lockeddate}
            </span>
            <button
              style={{
                display: "flex",
                backgroundColor: " red",
                border: "0px",
                color: "white",
                justifyContent: "space-evenly",
                padding: "10px",
                gap: "5px",
              }}
              onClick={() => toggle()}
            >
              <FaLock /> Unlock
            </button>
          </div>
        )}
        <div style={{ flex: "1", minWidth: "100%", maxWidth: "100%" }}>
          <EmployeeProfileCard
            isloading={isLoading}
            media={employeeProfileData.EmployeeMedia}
            customStyles={CustomStyle}
            requiredFields={requiredFields}
            employeeData={employeeProfileData}
            profileEdit={true}
            canEditJoinDate={true}
            canEditDOB={true}
            onChangeStatus={(id, value) =>
              updateStatus({ employeeId: id, status: value ? 1 : 0 })
            }
            onChangeCanLogin={(id, value) =>
              updateCanLogin({ employeeId: id, canLoginIntoApp: value ? 1 : 0 })
            }
            onSubmitJoinDate={(id, date) =>
              updateHrUserDates(
                { employeeId: id, joiningDate: date },
                {
                  onSuccess: () => {
                    showToast.success(
                      "Employee joining date updated successfully!"
                    );
                  },
                  onError: () => {
                    toast.error(" Failed to update joining date!");
                  },
                }
              )
            }
            onSubmitDOB={(id, date) =>
              updateHrUserDates(
                { employeeId: id, birthDate: date },
                {
                  onSuccess: () => {
                    showToast.success(
                      "Employee birth date updated successfully!"
                    );
                  },
                  onError: () => {
                    toast.error("❌ Failed to update birth date!");
                  },
                }
              )
            }
            // onEditProfileClick={() => setIsEditProfileModalOpen(true)}
          />
        </div>

        {/* Second Card */}
        <div
          style={{
            flex: "1",
            minWidth: "100%",
            maxWidth: "100%",
            marginBottom: "20px",
          }}
        >
          <AttendanceList employeeData={employeeProfileData} />
        </div>
      </div>

      {/* Third Card */}
      {employeeProfileData?.EmployeeId && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "space-between",
            padding: "0px 20px 20px 20px",
            width: "100%",
          }}
        >
          <div style={{ flex: "1", minWidth: "320px", maxWidth: "100%" }}>
            <LeaveList Employee={employeeProfileData.EmployeeId} />
          </div>
          <div style={{ flex: "0.6", minWidth: "320px", maxWidth: "100%" }}>
            <LeaveBalanceList Employee={employeeProfileData} />
          </div>
        </div>
      )}

      {/* Fourth Card */}
      <div
        className=""
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px", // Spacing between the cards
          justifyContent: "space-between",
          padding: "0px 20px 20px 20px",
          width: "100%",
        }}
      >
        {/* <div style={{ flex: "0.8", minWidth: "320px", maxWidth: "100%" }}>
          <BalanceList />
        </div> */}
        <div style={{ flex: "1", minWidth: "320px", maxWidth: "100%" }}>
          <SGPIList Employee={employeeProfileData.EmployeeId} />
        </div>
        <div style={{ flex: "1", minWidth: "100%", maxWidth: "100%" }}>
          <AccountInformation />
        </div>
      </div>
      <RouteModal
        isOpen={isEditProfile}
        toggle={toggleModal}
        title={"Edit User"}
        size="lg"
        content={
          <UserProfileModal
            EmployeeId={employeeData.EmployeeId}
            toggleModal={toggleModal}
          />
        }
      />

      <RouteModal
        isOpen={isResetPassModalOpen}
        toggle={resetPasswordToggleModal}
        title={"Reset Password"}
        size="lg"
        content={ResetPasswordModalContent()}
      />

      <RouteModal
        toggle={toggle}
        isOpen={isAccountLocked}
        size="sm"
        content={
          <AccountLockedModal
            toggle={toggle}
            data={employeeProfileData}
            onUnlocked={() => {
              setProfileData((prev: any) => ({
                ...prev,
                Islocked: false,
                LockedReason: null,
                Lockeddate: null,
              }));
            }}
          />
        }
      />
    </div>
  );
};

export default EmployeeDetails;
